module.exports = __webpack_public_path__ + "img/DE06179.857348c0.png";